import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWithPageLoadLoader from './components/AppWithPageLoadLoader';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';



const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

root.render(
  <BrowserRouter>
    <AppWithPageLoadLoader />
  </BrowserRouter>
);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <App />
// );


reportWebVitals();


